export default __webpack_public_path__ + "static/media/burbuje.7ea91fca.svg";